import { formatMarineDateChart } from "@/helpers/format-date";
import { IMarineForecastData } from "@/schemas/marine-forecast-schema";
import { useChartWidth } from "recharts";

type CustomTickProps = {
	x: number | string;
	y: number | string;
	data: IMarineForecastData;
	windowWidth: number;
	payload: {
		coordinate: number;
		index: number;
		isShow?: boolean;
		offset?: number;
		tickCoord?: number;
		value: string;
	};
};

export const CustomTick = ({
	x,
	y,
	payload,
	data,
	windowWidth,
}: CustomTickProps) => {
	const width = useChartWidth();

	const time = new Intl.DateTimeFormat("en-GB", {
		timeZone: "Asia/Kuwait",
		hour: "2-digit",
		minute: "2-digit",
		hourCycle: "h23",
	}).format(new Date(payload.value));

	const [hours, min] = time.split(":").map(Number);
	if (min === 1) return null;

	const hourLabel = hours > 9 ? hours.toString() : `0${hours}`;
	const subLabel = hours === 0;

	const coordinateX = typeof x === "number" ? x : parseFloat(x);

	const chartWidth = width || 0;

	const sectionWidth =
		(chartWidth - (windowWidth > 600 ? 200 : 100)) /
		(data.length === 2 ? 1 : data.length - 1);

	const middleOffset = sectionWidth / 2;

	return (
		<g transform={`translate(${coordinateX + middleOffset}, ${y})`}>
			<text textAnchor="middle" fontSize={16} fill="#133D61">
				<tspan x="0" dy="5">
					{hourLabel}
				</tspan>
				{subLabel && (
					<tspan x="0" dy="10" fontSize={12}>
						{formatMarineDateChart(payload.value)}
					</tspan>
				)}
			</text>
		</g>
	);
};

export default CustomTick;
